import { Roles } from 'constants/index';
import { User } from 'types';

type UserIdentity = Pick<User, 'first_name' | 'last_name' | 'email'>;

const roleLabels: Record<string, string> = {
  [Roles.SUPERADMIN]: 'Superadministrador',
  [Roles.ADMIN]: 'Administrador',
  [Roles.SUPERVISOR]: 'Supervisor',
  [Roles.OPERATOR]: 'Operador',
  [Roles.CLIENT]: 'Cliente',
};

export function getUserDisplayName(user: UserIdentity | null) {
  if (!user) return 'Usuario';
  return [user.first_name, user.last_name].filter(Boolean).join(' ') || user.email || 'Usuario';
}

export function getUserInitials(user: UserIdentity | null) {
  const nameInitials = [user?.first_name, user?.last_name]
    .filter(Boolean)
    .map(part => part?.charAt(0))
    .join('')
    .toUpperCase();

  return nameInitials || getUserDisplayName(user).charAt(0).toUpperCase();
}

export function getUserRoleLabel(role?: string | null) {
  return role ? roleLabels[role] || role : null;
}
